<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <Features></Features>
    <TecAndSer></TecAndSer>
    <CompanyHonor></CompanyHonor>
    <CooperativeOrganization></CooperativeOrganization>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import Features from "@/components/Home/Features"
  import TecAndSer from "@/components/Home/TecAndSer"
  import CompanyHonor from "@/components/Home/CompanyHonor"
  import CooperativeOrganization from "@/components/Home/CooperativeOrganization"

  export default {
    name: 'Home',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-home.png")
      }
    },
    components: {
      Header,
      Banners,
      Footer,
      Features,
      TecAndSer,
      CompanyHonor,
      CooperativeOrganization
    },
    created() {
      this.$store.commit('changeNavs', 'Home')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue